<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img"><img src="/assets/product/engine/4G15H/4G15H.jpg" alt=""></div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">4G15H 1.5L Naturally Aspirated Hybrid Gasoline Engine</div>
                <div class="detail-banner-desc">
                    The 4G15H is a 1.5L high-efficiency hybrid naturally aspirated gasoline engine specially designed to match hybrid vehicles, delivering a maximum of 95 horsepower and a minimum BSFC of 220 g/kW·h.
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">Powerful Performance</div>
        <div class="detail-desc">Low initial speed for maximum torque with a wide effective range ensures smooth acceleration and ample power, enhancing driving refinement.</div>
        <div class="detail-utils">
            <div class="detail-utils-item">
                <div class="detail-utils-d">Maximum Power（6000r/min）</div>
                <div class="detail-utils-u">70kW</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">Maximum Torque（4800r/min）</div>
                <div class="detail-utils-u">125N·m</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">Low-Speed Torque</div>
                <div class="detail-utils-u">1000r/min 90N·m<br />1200r/min 95N·m</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">Emission Standard</div>
                <div class="detail-utils-u">China 6b</div>
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4G15H/4G15H-1.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        High Compression Ratio + New Combustion System
                    </div>
                    <div class="detail-desc">
                        A newly designed combustion system incorporates a high compression ratio, Atkinson cycle, and efficient ignition technology to increase thermal efficiency and power output.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">Low Fuel Consumption</div>
        <div class="detail-desc">Utilizes innovative technologies such as EGR and an intelligent electric water pump cooling system, along with friction-reduction measures, for more efficient combustion and lower fuel consumption.</div>
        <div class="detail-four-list">
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15H/4G15H-2.jpg" alt=""></img>
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    EGR (Exhaust Gas Recirculation)
                </div>
                <div class="detail-four-desc">
                    Reduces pumping losses at partial load, lowers combustion temperatures, suppresses knock, and significantly improves fuel economy.
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    Intelligent Cooling System
                </div>
                <div class="detail-four-desc">
                    An electric water pump enables smart closed-loop cooling control. It automatically identifies engine operating conditions, raising coolant temperature targets at medium loads to reduce friction losses and fuel consumption.
                </div>

            </div>
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15H/4G15H-3.jpg" alt=""></img>
                </div>
            </div>
        </div>
    </div>


    <div class="detail-box">
        <div class="detail-title">NVH</div>
        <div class="detail-desc">Acoustic refinement has been enhanced through quiet-optimized components for a more pleasant engine sound.</div>
        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4G15H/4G15H-4.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        Plastic Intake Manifold
                    </div>
                    <div class="detail-desc">
                        The intake manifold is made of plastic material to reduce engine noise and improve NVH.
                    </div>
                </div>
            </div>
        </div>
    </div>


    <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
    nextTick(() => {
        const swiperContainers = document.querySelectorAll('.swiper-container');

        swiperContainers.forEach((container, index) => {
            const containerKey = `swiper_${index}`;
            container.dataset.swiperKey = containerKey;
            const swiperInstance = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 300,
                preventClicks: true,
                effect: 'fade',
            });
            swiperInstances.value[containerKey] = swiperInstance;
        });

        bindTabClickEvent();
    });
});
function bindTabClickEvent() {
    const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

    allSwiperLists.forEach((swiperList) => {
        const tabItems = swiperList.querySelectorAll('.detail-tab-item');
        const targetSwiperContainer = swiperList.querySelector('.swiper-container');

        if (!tabItems.length || !targetSwiperContainer) return;

        const containerKey = targetSwiperContainer.dataset.swiperKey;
        const targetSwiper = swiperInstances.value[containerKey];
        if (!targetSwiper) return;

        const handleTabAction = (tabItem, localTabIndex) => {
            tabItems.forEach(item => item.classList.remove('active'));
            tabItem.classList.add('active');
            targetSwiper.slideTo(localTabIndex, 300, true);
        };
        tabItems.forEach((tabItem, localTabIndex) => {
            const handleTabClickWrapper = () => {
                handleTabAction(tabItem, localTabIndex);
            };
            tabItem.removeEventListener('click', handleTabClickWrapper);
            tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
            tabItem.addEventListener('click', handleTabClickWrapper);
            tabItem.addEventListener('mouseenter', handleTabClickWrapper);
        });
    });
}

</script>

<script>
export const pageConfig = {
  title: '44G15H 1.5L Naturally Aspirated Hybrid Gasoline Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4G15H.html'

};

import { createApp } from 'vue';
import App from './4G15H.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./4G15H.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>